<template>
  <div class="step--services">
    <vue-headful title="Services" />
    <StepTitle>Choose Services</StepTitle>
    <ServicesLoader v-if="isLoading" />
    <template v-else>
      <ServicesDifferenceWarning />
      <ServicesForm
        :model="selectedServices"
        :serviceGroups="serviceGroups"
        @save="save"
        @submit="submit" />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import ServicesDifferenceWarning from '@/components/ServicesDifferenceWarning.vue';
import ServicesLoader from '@/components/ServicesLoader.vue';
import ServicesForm from '@/components/forms/ServicesForm.vue';
import StepTitle from '@/components/StepTitle.vue';
import RouteNameConstants from '@/router/constants/route-names';
import StepUtilities from '@/router/utilities/step-utilities';

export default {
  components: {
    ServicesDifferenceWarning,
    ServicesForm,
    ServicesLoader,
    StepTitle,
  },
  data() {
    return {
      hydrated: false,
      serviceGroups: [],
    };
  },
  inject: ['$validator'],
  computed: {
    ...mapState('Appointment', {
      selectedInspectorId: state => state.dateComponentData.inspectorId,
      selectedServices: state => state.servicesComponentData.selectedServices,
    }),
    ...mapState('Company', {
      companyId: state => (state.company ? state.company.id : null),
    }),
    ...mapState('Services', {
      error: state => state.error,
      loading: state => state.loading,
    }),
    ...mapGetters('Services', ['servicesForInspector']),
    isLoading() {
      return !!(this.loading || !this.hydrated);
    },
  },
  mounted() {
    this.initialHydration();
    this.$store.commit('setStepIndex',
      StepUtilities.getStepIndexByRouteName(RouteNameConstants.AppointmentServices));
  },
  methods: {
    ...mapActions('Appointment', [
      'loadServicesEstimate',
      'removeService',
      'resetServicesEstimate',
      'setServices',
    ]),
    async initialHydration() {
      this.serviceGroups = this.servicesForInspector(this.selectedInspectorId);
      this.hydrated = true;
    },
    async save(data) {
      await this.setServices(data);
      if (!this.selectedServices || this.selectedServices.length === 0) {
        await this.resetServicesEstimate();
        return;
      }
      await this.loadServicesEstimate();
    },
    async submit(data) {
      try {
        await this.save(data);
        StepUtilities.goToNextStep(this.$route, this.$router);
      } catch (err) {
        // eat the error
      }
    },
  },
};
</script>
